export enum SiteWorkflowState {
    Setup = 'Setup',
    Active = 'Active',
    Closed = 'Closed'
}
